export default function BackedBy() {
  const logos = [
    { src: "/logo192.png", alt: "Logo 1" },
    { src: "/logo192.png", alt: "Logo 2" },
    { src: "/logo192.png", alt: "Logo 3" },
  ];

  return (
    <section className="flex flex-col items-center w-full p-8 bg-[--color-background]">
      {/* Title */}
      <h2 className="text-4xl font-bold mb-4 text-text">Backed by</h2>

      {/* Logos Container */}
      <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0 bg-[--color-background] w-full items-center justify-between">
        {logos.map((logo, index) => (
          <div
            key={index}
            className="flex items-center justify-center w-full sm:w-64 h-32 bg-white rounded-xl shadow-lg p-4 transition-transform transform hover:scale-105"
          >
            <img src={logo.src} alt={logo.alt} className="max-h-full" />
          </div>
        ))}
      </div>
    </section>
  );
}
